export const formatString = (input: string): string => {
  if (/[a-z][A-Z]/.test(input)) {
    return input
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^\w/, c => c.toUpperCase());
  } else {
    return input.charAt(0).toUpperCase() + input.slice(1);
  }
};

export const stripHtmlTags = (input?: unknown) => {
  if (typeof input === 'string' && input.length > 0) {
    return input.replace(/<[^>]*>/g, '');
  }

  // AN OBJECT MUST NEVER REACH A <td>. React throws on an object child, and
  // with no error boundary anywhere in this app the throw unmounts the whole
  // root — a white screen, not a broken cell. Handing the object back "as-is"
  // is exactly what let a JSONB column do that. Arrays are deliberately left
  // alone: `names`/`lastNames` are arrays on purpose and their callers map
  // over them.
  if (input !== null && typeof input === 'object' && !Array.isArray(input)) {
    return String(input);
  }

  return input as string | undefined; // Return the input as-is if it's not a string
};
